import React from 'react';
import { Container, Progress } from 'reactstrap';
import { CHeader, CFooter, CContainer } from '@coreui/react';
import { connect } from 'react-redux';
import WhiteLabelFooter from '../WhiteLabelLayout/DefaultFooter';
import SetupAccountHeader from './SetupAccountHeader';
import WhiteLabelHeader from '../WhiteLabelLayout/DefaultHeader';

import SetupAccount from '../../elements/SetupAccount';

// Types
interface WhiteLabel {
  active?: boolean;
  [key: string]: any;
}

interface StateProps {
  whiteLabel?: WhiteLabel | null;
  isMobileDevice?: boolean;
}

const SetAccount: React.FC<StateProps> = ({ whiteLabel, isMobileDevice }) => (
  <div className="app">
    <CHeader position="fixed">
      <CContainer fluid>
        {whiteLabel && whiteLabel.active ? <WhiteLabelHeader onlyLogout /> : <SetupAccountHeader />}
      </CContainer>
    </CHeader>
    <div className="app-body">
      <Container fluid>
        {/* @ts-ignore */}
        {1 === 2 && isMobileDevice && (
          <Progress
            className="h-30 top-fixed-progess"
            animated
            color="success"
            value={window.value || 30}
            max={100}
          />
        )}
        <SetupAccount />
      </Container>
    </div>
    <CFooter>
      <WhiteLabelFooter />
    </CFooter>
  </div>
);

const mapStateToProps = ({ auth, environment }: any): StateProps => ({
  whiteLabel: auth?.whiteLabel ?? null,
  isMobileDevice: environment?.isMobileDevice
});

export default connect<StateProps, unknown, unknown, any>(mapStateToProps, null)(SetAccount);
